var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BarChart',_vm._b({},'BarChart',{ options: _vm.options, data: _vm.data, styles: _vm.styles, params: _vm.params, refresh: _vm.refresh, height: _vm.height },false))
}
var staticRenderFns = []

export { render, staticRenderFns }